import { ISocketNotificationEvent } from '../../services/websockets/types';
import { IThread } from '../api/models/thread/thread.types';
import { INewMessageAttributes } from '../messages/types';

interface INewThreadSerializer extends INewMessageAttributes {
  threadMainPicture: string;
  threadId: string;
  messageId: string;
}

export const threadSerializer = (
  rawMessage: ISocketNotificationEvent,
  { accountId, threadMainPicture, threadId, messageId }: INewThreadSerializer
): IThread => ({
  id: threadId ? threadId : rawMessage.message.thread_id,
  relationships: {
    accountId,
    threadMainPicture,
    messages: {
      list: [messageId],
      meta: {},
    },
  },
  permissions: {},
});
